export default {
    current_language: 'en',
    shadowLoaderStatus: false
}